import { useContext } from 'react';
import { authContext, AuthContextType } from './auth-context';

export const useAuthContext = (): AuthContextType => {
  const context = useContext(authContext);
  if (context === undefined) {
    throw new Error('useAuthContext must be used within an AuthProvider');
  }
  return context;
};
